import { useContext, useEffect } from 'react';
import {
  getSessionStorageValue,
  SESSION_STORAGE_KEYS,
  setSessionStorageValue
} from '@namespace/helpers';
import {
  getSocketInstance,
  socketSend,
  socketSubscribe
} from '@namespace/socket';
import { TelegramAppContext } from '@namespace/telegram-app';
import { UserContext } from '@namespace/user';
import {
  IS_WIDGET,
  POST_MESSAGE_TYPES,
  usePostMessage,
  WidgetContext
} from '@namespace/widget';

const { SSID, MOUNT } = POST_MESSAGE_TYPES;

const useGetUserData = () => {
  const [, userActions] = useContext(UserContext);
  const [{ token: widgetToken }, { SET_SSID }] = useContext(WidgetContext);
  const [{ initData }] = useContext(TelegramAppContext);
  const { postMessage } = usePostMessage();
  const { FETCH_USER_DATA_FOR_WIDGET, FETCH_USER_DATA, TELEGRAM_AUTH } =
    userActions;

  useEffect(() => {
    if (IS_WIDGET) {
      socketSubscribe({
        name: 'ssid_update',
        types: ['ssid_update'],
        callback: ({ data: { ssid } }) => {
          SET_SSID(ssid);
          postMessage(SSID, ssid);

          if (widgetToken) {
            socketSend({
              cmd: 'do_proto_v1', // todo 'accounting/login'
              data: {
                query: {
                  login: {
                    variables: {
                      token: widgetToken
                    }
                  }
                }
              }
            });
          }
          FETCH_USER_DATA_FOR_WIDGET().finally(() => {
            postMessage(MOUNT, '');
          });
        }
      });
    } else if (initData) {
      const interval = setInterval(() => {
        if (getSocketInstance().isOpen) {
          clearInterval(interval);
          TELEGRAM_AUTH(initData)
            .catch(console.error)
            .finally(() =>
              FETCH_USER_DATA().catch(() => {
                if (!getSessionStorageValue(SESSION_STORAGE_KEYS.RELOAD_PAGE)) {
                  window.location.reload();
                  setSessionStorageValue(
                    SESSION_STORAGE_KEYS.RELOAD_PAGE,
                    true,
                    {
                      expires: new Date(new Date().getTime() + 600000) // 10 min
                    }
                  );
                }
              })
            );
        }
      }, 100);
    } else {
      FETCH_USER_DATA().catch(console.error);
    }
  }, [widgetToken, initData]);
};

export default useGetUserData;
